export default __webpack_public_path__ + "static/media/icon-facebook.a9208377.svg";